import SwaggerParser from '@apidevtools/swagger-parser';
import { parse } from 'csv-parse/browser/esm/sync';
import yaml from 'js-yaml';

export default {
    methods: {
        parseCsv(content) {
            return parse(content, { skip_empty_lines: true });
        },

        readFile(evt, callback) {
            let reader = new FileReader();
            let fileObj = evt.target;
            if (fileObj.files && fileObj.files[0]) {
                reader.onload = (evt2) => {
                    if (callback) {
                        callback(evt2.target.result);
                    } else {
                        this.fileOnLoad(evt2.target.result);
                    }
                };
                reader.readAsText(fileObj.files[0]);
            } else {
                return false;
            }

            return true;
        },

        readOpenAPIFile(evt) {
            let reader = new FileReader();
            let fileObj = evt.target;
            if (fileObj.files && fileObj.files[0]) {
                reader.onload = (evt2) => {
                    try {
                        const obj = yaml.load(evt2.target.result);
                        SwaggerParser.validate(obj, (err, data) => {
                            if (err) {
                                this.fileOnLoad('', '', 400);
                            } else {
                                this.fileOnLoad(data, evt2.target.result);
                            }
                        });
                    } catch (e) {
                        this.fileOnLoad('', '', 400);
                    }
                };
                reader.readAsText(fileObj.files[0]);
            }
        },
    },
};
